module.exports = __webpack_public_path__ + "static/img/right-num-row-7.06f30a15.png";